module.exports = __webpack_public_path__ + "img/09.56e2e53b.jpg";